const defaultChargeRecord = {
  chargeTypeValue: "Freight Charge",
  chargeType: "Freight Charge",
  chargeGroupCode: "CARGO",
  calculationType: "UNIT",
  unitType: "CHARGEABLE_WEIGHT",
  requestAmount: false,
  quantity: "",
  baseRate: "",
  baseRateCurrency: "",
  baseRateTotal: "",
  usdRateTotal: "",
  chargeTypeObject: {
    code: "FREIGHT",
    chargeGroupCode: "CARGO",
    calculationType: "UNIT",
    unitType: "CHARGEABLE_WEIGHT",
    value: "Freight Charge",
    data: {"chargeGroupCode":"CARGO","calculationType":"UNIT","unitType":"CHARGEABLE_WEIGHT","requestAmount":false},
  }
}

const defaultDgRecord = {
  chargeTypeValue: "Dangerous Goods Charge",
  chargeType: "Dangerous Goods Charge",
  chargeGroupCode: "ADDITIONAL",
  calculationType: "FIXED",
  unitType: "QUANTITY",
  requestAmount: false,
  quantity: "",
  baseRate: "",
  baseRateCurrency: "",
  baseRateTotal: "",
  usdRateTotal: "",
  chargeTypeObject: {
    code: "DG",
    chargeGroupCode: "ADDITIONAL",
    calculationType: "FIXED",
    unitType: "QUANTITY",
    value: "Dangerous Goods Charge",
    data: {"chargeGroupCode":"ADDITIONAL","calculationType":"FIXED","unitType":"QUANTITY","requestAmount":true},
  }
}

export {
  defaultChargeRecord,
  defaultDgRecord
};
